import React, { useEffect, useState } from "react";

import { Layout, PageHeader, Button, Tabs } from 'antd';

//import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { PictureOutlined, PictureFilled } from '@ant-design/icons';

import { logOut, getRCValue, uploadFile, setRCValue } from '../context/firebaseConfig'
import '../assets/css/banners.css'

import BannerForm from '../components/BannerForm'
import { Spin } from "antd";

const { Content, Footer} = Layout;
const { TabPane } = Tabs;


const Banners = () => {
    //const nav = useNavigate();
    const { t } = useTranslation();

    const [banners, setBanners] = useState([]);
    const [tabs, setTabs] = useState([]);
    const [toSave, setToSave] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect( () => {
        async function petete() {
            const va =  await getRCValue()
            const ba = JSON.parse(va._value);
            setBanners(ba);
            setToSave(ba);
        }
        petete();
    }, []);
 
    useEffect(() => {
        async function setTabas() {
            let tabas = []
            toSave.forEach(banner => {
                tabas.push(<TabPane tab={<span><PictureOutlined />{t(`BANNER_${banner.index}`)}</span>} key={`tabKey${banner.index}`}>
                    <BannerForm key={`bannerForm_${banner.index}`} banner={banner} callback={fcallback} id={`tabKey${banner.index}`}/>
                </TabPane>)
            })
            setTabs(tabas)
        }
        setTabas();
    },[toSave])
 
    const fcallback = (data) => {
        let a = [...toSave];
        a[data.index-1] = data;
        setToSave(a);
    }

    const saveMazo = async () => {
        var changed = false;
        let toSaveMazo = [];
        for(var i = 0; i < 4 && !changed; i++) {
            changed = JSON.stringify(banners[i]) !== JSON.stringify(toSave[i]);
        } 
        if(changed) {
            setLoading(true)
            for(var i = 0; i < toSave.length; i++) {
                const ss = toSave[i];
                if(ss.f) {
                    const keys = Object.keys(ss.f);
                    for(var j = 0; j < keys.length; j++) {
                        const key = keys[j];
//console.log(`subendo fichero ${ss.f[key].name}`)
                        try {
                            const res = await uploadFile(ss.f[key]);
                            if(res) {
                                ss[`imageUrl_${key}`] = res;
                            }
                        } catch(e) {
                            console.log(e)
                        }
                    }
                    delete ss.f;
                }
                toSaveMazo.push(ss)
            }
//console.log(JSON.stringify(toSaveMazo));
            setRCValue(JSON.stringify(toSaveMazo));
            //setRCValue(toSaveMazo);
            setLoading(false);
            setBanners(toSaveMazo);
        } else alert(`No hi ha canvis per desar`);
    }

    function callback(key) {
      /* console.log(key);
      var i = Number(key.replace('tabKey', ''));
      console.log(toSave) */
    }

    return (
        !loading ?
            <Layout>
                <PageHeader
                style={{ backgroundColor: "#FFF", height: "100px", padding: 0,}}
                ghost='false'
                title={<img src='/assets/img/logo-land.png' alt='Crédit Assegurances Vida' style={{ maxHeight: "100px"}}/>}
                extra={[
                    <React.Fragment key='banners_fragment_1'>
                            <Button onClick={() => { logOut(); }} key="logout" 
                                type="primary" style={{marginRight: '15px'}}>{t('BUTTON_LOGOUT')}</Button> 
                        </React.Fragment>                     
                    ]}
                    />
                    <Content className="" style={{marginLeft: '20px'}}>
                    <Tabs defaultActiveKey="1" onChange={callback}>
                        {tabs}
                        {/* <TabPane tab={<span><PictureOutlined/>{t(`BANNER_1`)}</span>} key="tabKey1">
                            <BannerForm key="bannerForm_1" {...banners[0]}/>
                        </TabPane>
                        <TabPane tab={<span><PictureOutlined/>{t(`BANNER_2`)}</span>} key="tabKey11">
                        {<BannerForm key="bannerForm_2" {...banners[1]}/>} PP
                        </TabPane>
                        <TabPane tab={<span><PictureOutlined/>{t(`BANNER_3`)}</span>} key="tabKey3">
                        { } PP
                        </TabPane>
                        <TabPane tab={<span><PictureOutlined/>{t(`BANNER_4`)}</span>} key="tabKey4">
                        {<BannerForm key="bannerForm_4" {...banners[3]}/>} PP
                    </TabPane> */}
                    </Tabs>
                    
                </Content>
                <Footer>
                    <Button onClick={() => { saveMazo(); }} key="btn_save" 
                        type="primary" style={{marginRight: '15px'}}>{t('BTN_SAVE')}</Button> 
                </Footer>
            </Layout>
        :
            <Content style={{display: "flex", alignItems:"center", justifyContent:"center", width:"100%", height:"100vh"}}>
                <Spin />
            </Content>
    )
}

export default Banners;

/*
[
	{
		"index": 1,
		"url_ca":"https://www.creditvida.ad/vida/",
		"imageUrl_ca":"https://www.creditvida.ad/web/app/uploads/2022/04/Asseg-1260x600-Slider_Cat.jpg",
		"url_es":"ttps://www.creditvida.ad/vida/?lang=es",
		"imageUrl_es":"https://www.creditvida.ad/web/app/uploads/2022/04/Asseg-1260x600-Slider_Es.jpg",
		"url_en":"https://www.creditvida.ad/life/?lang=en",
		"imageUrl_en":"https://www.creditvida.ad/web/app/uploads/2022/04/Asseg-1260x600-Slider_Eng.jpg",
		"url_fr":"https://www.creditvida.ad/vie/?lang=fr",
		"imageUrl_fr":"https://www.creditvida.ad/web/app/uploads/2022/04/Asseg-1260x600-Slider_Fr.jpg"
	},
	{
		"index": 2,
		"url_ca":"https://www.creditvida.ad/assistencia-sanitaria-mundial/",
		"imageUrl_ca":"https://www.creditvida.ad/web/app/uploads/2022/02/AssistenciaMundial_1260x600_CAT.jpg",
		"url_es":"https://www.creditvida.ad/asistencia-sanitaria-mundial/?lang=es",
		"imageUrl_es":"https://www.creditvida.ad/web/app/uploads/2022/02/AssistenciaMundial_1260x600_ES.jpg",
		"url_en":"https://www.creditvida.ad/worldwide-medical-assistance/?lang=en",
		"imageUrl_en":"https://www.creditvida.ad/web/app/uploads/2022/02/AssistenciaMundial_1260x600_ENG.jpg",
		"url_fr":"https://www.creditvida.ad/assistance-medicale-dans-le-monde-entier/?lang=fr",
		"imageUrl_fr":"https://www.creditvida.ad/web/app/uploads/2022/02/AssistenciaMundial_1260x600_FR.jpg"
	},
	{
		"index": 3,
		"url_ca":"https://www.creditvida.ad/contractar-assegurances/",
		"imageUrl_ca":"https://www.creditvida.ad/app/uploads/2020/12/1Cat-Assegurances-1260x600.jpg",
		"url_es":"https://www.creditvida.ad/contratar-seguros/?lang=es",
		"imageUrl_es":"https://www.creditvida.ad/web/app/uploads/2020/12/2Cast-Assegurances-1260x600.jpg",
		"url_en":"https://www.creditvida.ad/take-out-insurance/?lang=en",
		"imageUrl_en":"https://www.creditvida.ad/web/app/uploads/2020/12/4Eng-Assegurances-1260x600.jpg",
		"url_fr":"https://www.creditvida.ad/souscrire-assurances/?lang=fr",
		"imageUrl_fr":"https://www.creditvida.ad/web/app/uploads/2020/12/3Fr-Assegurances-1260x600.jpg"
	},
	{
		"index": 4,
		"url_ca":"https://www.creditvida.ad/one-click-transactions/?lang=ca",
		"imageUrl_ca":"https://www.creditvida.ad/web/app/uploads/2020/04/Slider_web_assegurances_vida_1260x600_CAT.png",
		"url_es":"https://www.creditvida.ad/gestiones-en-un-clic/?lang=es",
		"imageUrl_es":"https://www.creditvida.ad/web/app/uploads/2020/04/Slider_web_assegurances_vida_1260x600_ESP.png",
		"url_en":"https://www.creditvida.ad/one-click-transactions/?lang=en",
		"imageUrl_en":"https://www.creditvida.ad/web/app/uploads/2020/04/Slider_web_assegurances_vida_1260x600_ENG.png",
		"url_fr":"https://www.creditvida.ad/gestions-en-un-clic/?lang=fr",
		"imageUrl_fr":"https://www.creditvida.ad/web/app/uploads/2020/04/Slider_web_assegurances_vida_1260x600_FR.png"
	}
]

*/